// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SmallDashOutlinedSvg from "@fishx/icons-svg/es/asn/SmallDashOutlined";
import FishxIcon from '../components/FishxIcon';

var SmallDashOutlined = function SmallDashOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SmallDashOutlinedSvg
  }));
};

SmallDashOutlined.displayName = 'SmallDashOutlined';
export default React.forwardRef(SmallDashOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SmallDashOutlined.js
// module id = 4156
// module chunks = 0